import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import AccountLinking from '../account-linking/account-linking';
import Settings from '../settings/settings';
import Addresses from '../addresses/addresses';
import Billing from '../billing/billing';

export const childrenOfAccount = [
  {
    path: RoutingConstants.AccountLinking,
    element: <AccountLinking />
  },
  {
    path: RoutingConstants.Settings,
    element: <Settings />
  },
  {
    path: RoutingConstants.SavedAddresses,
    element: <Addresses />
  },
  {
    path: RoutingConstants.Billing,
    element: <Billing />
  }
];

export const routesOfAccount = childrenOfAccount.map((r) => r.path);

export const sanitisedRoutesOfAccount = routesOfAccount;
